/*
 * Copyright (c) RECREWT GmbH 2022.
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { JobGeneral } from '@data/job-general/job-general.model';
import { DataBaseService } from '@data/data.base.service';
import { JobGeneralStore } from '@data/job-general/job-general.store';
import { JobGeneralQuery } from '@data/job-general/job-general.query';

@Injectable({
  providedIn: 'root',
})
export class JobGeneralService extends DataBaseService<JobGeneral> {
  constructor(
    http: HttpClient,
    jobGeneralStore: JobGeneralStore,
    jobGeneralQuery: JobGeneralQuery,
  ) {
    super(http, jobGeneralStore, jobGeneralQuery, 'jobs/general');
  }
}
